import { z } from 'zod';

export const ApiErrorMessageSchema = z.enum([
  'NO_CURRENT_RUN_FOUND',
  'API_CALL_IS_LOCKED',
]);

export type ApiErrorMessageType = z.infer<typeof ApiErrorMessageSchema>;

export const ApiErrorMessage = ApiErrorMessageSchema.enum;
